import { EMPTY_STRING } from "../../common/commonStrings";
import { ProductWithCmsDataAndQualification } from "../../pages/ProductsListPage/entities/product-with-cms-data-and-qualification/product-with-cms-data-and-qualification.entity";
import { IProductWithCmsDataAndQualification } from "../../pages/ProductsListPage/entities/product-with-cms-data-and-qualification/product-with-cms-data-and-qualification.entity.interface";
import { Mapper } from "../../utils/mapper";
import { ApiClientBonusxProductsRepository } from "../ApiClientBonusXServiceRepository/ApiClientBonusxProductsRepository";
import { ApiClientBonusxServiceRepository } from "../ApiClientBonusXServiceRepository/ApiClientBonusxServiceRepository";
import { IProduct } from "../ApiClientBonusXServiceRepository/interfaces/IProduct.interface";
import { IBonusxProductsService } from "./BonusxProductsService.interface";

export class BonusxProductsService implements IBonusxProductsService {
  constructor(
    private readonly _legacyApiRepository = new ApiClientBonusxServiceRepository(),
    private readonly _latestApiRepository = new ApiClientBonusxProductsRepository()
  ) {}

  public async getProductById(id: number): Promise<IProduct> {
    const product = (await this._legacyApiRepository.getServiceById(id)) as IProduct;
    const normalizedProduct = this._normalizeProductName(product);

    return normalizedProduct;
  }

  private _normalizeProductName(product: IProduct): IProduct {
    const productName = product.name || product.cms?.name || EMPTY_STRING;
    const productShortDescription = product.shortDescription || product.cms?.shortDescription || EMPTY_STRING;

    const normlizedProduct = { ...product, name: productName, shortDescription: productShortDescription };
    return normlizedProduct;
  }

  public async getAllProducts(): Promise<IProductWithCmsDataAndQualification[]> {
    const products = await this._latestApiRepository.getAllProducts();

    const productEntities = Mapper.mapArrayData(ProductWithCmsDataAndQualification, products);
    return productEntities;
  }
}
